import { useState } from "react";
import {
  CustomContainer,
  Row,
  Col,
  Text,
  Progress,
  OwlCarousel,
  Container
} from "../../atoms/DependencyHelper";
import PageHeading from "../../atoms/pageHeading/PageHeading";
import Image from "../../atoms/image/image";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import PropTypes from "prop-types";
import { createMarkup } from "../../../utils/helperServices";
import styles from "./StepProcess.module.scss";

const StepProcess = ({ className, metaData }) => {
  const imageType = metaData && metaData.items && metaData.items[0].imageStyle;
  const [activeStep, setActiveStep] = useState(metaData?.items[0]);

  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");

  const options = {
    items: 1,
    nav: true,
    autoplay: false,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots owl--dots--show",
    dotClass: "owl--dot owl--dot--l owl--dot--red",
    animateIn: "animate__fadeIn",
    responsive: {
      0: {
        slideBy: 1,
      }
    }
  };
  let carousel;
  const next = () => {
    if (carousel) {
      carousel.next(600);
    }
  };
  const prev = () => {
    if (carousel) {
      carousel.prev(600);
    }
  };

  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    const minimum = 0;
    const maximum = event.item.count;

    let previousNav = index <= minimum ? "disabled" : "";
    let nextNav =
      index +
        options.responsive[event.relatedTarget._breakpoint].slideBy >= maximum
        ? "disabled"
        : "";
    
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  const StepContent = ({ step, checkActive, onClickHandler, index }) => {
    const onClick = () => {
      if (onClickHandler) {
        onClickHandler(step);
      }
    };
    return (
      <CustomContainer
        className={styles["process-container"]}
        key={step.id}
        onClick={onClick}
        id={step.id}
        data-cms-title={step.analyticTitle}
      >
        <CustomContainer className={styles["process-number"]}>
          0{index + 1}
        </CustomContainer>
        <CustomContainer className={styles["process-details"]}>
          <Text
            className={`${styles["process-heading"]}  ${
              styles[
                checkActive
                  ? activeStep.id === step.id
                    ? "active-text"
                    : "inactive-text"
                  : "active-text"
              ]
            }`}
          >
            {step?.title}
          </Text>
          <CustomContainer
            className={`${styles["process-description"]} ${
              styles[
                checkActive
                  ? activeStep.id === step.id
                    ? "active-text"
                    : "inactive-text"
                  : "active-text"
              ]
            }`}
            dangerouslySetInnerHTML={createMarkup(step?.description)}
          ></CustomContainer>
          {checkActive && (
            <CustomContainer className={"pr-s d-none d-md-block "}>
              <Progress
                className={
                  styles[
                    activeStep.id === step.id
                      ? "progress-container"
                      : "inactive-progessbar"
                  ]
                }
                max={metaData.items && metaData.items.length}
                min={0}
                value={index + 1}
              />
            </CustomContainer>
          )}
        </CustomContainer>
      </CustomContainer>
    );
  };
  const MobileContent = (
    <>
      <CustomContainer className={"owl-wrapper"}>
        <OwlCarousel ref={(c) => (carousel = c)} options={options} events={events}>
          {metaData?.items.map((step, index) => (
            <Row noGutters={true} className={`${className}${styles["mobile-container"]}`} key={step.id}>
              <Col xs={12} className={`${styles["top-col"]}`}>
                <CustomContainer
                  style={{ backgroundImage: "url(" + step?.image + ")" }}
                  className={
                    imageType === "Landscape Image"
                      ? styles["image-container-landscape"]
                      : styles["image-container-square"]
                  }
                />
              </Col>
              <Col xs={12} className={`${styles["bottom-col"]}`}>
                <PageHeading text={metaData?.title} />
                <StepContent step={step} index={index} key={step.id}/>
              </Col>
            </Row>
          ))}
        </OwlCarousel>
      </CustomContainer>
      <CustomContainer className={`custom-owl--nav ${styles["custom-container-button"]}`}>
        <CarouselButton
          prev
          className={`${styles["prev-btn"]} ${previousNavClass}`}
          handleClick={prev}
          variant="oval"
          btnSize="sm"
          id="StepProcess_arrowBackBtn"
        />
        <CarouselButton
          next
          className={`${styles["next-btn"]} ${nextNavClass}`}
          handleClick={next}
          variant="oval"
          btnSize="sm"
          id="StepProcess_arrowNextBtn"
        />
      </CustomContainer>
    </>
  );
  return (
    <>
      <Row className={`${className} d-none d-lg-flex`}>
        <Col md={6} className={`${styles["bottom-col"]} pr-3`}>
          <PageHeading
            text={metaData?.title}
          />
          <CustomContainer className={styles["process-steps"]}>
            {metaData?.items.map((step, index) => (
              <StepContent
                step={step}
                checkActive
                onClickHandler={setActiveStep}
                key={step.id}
                index={index}
              />
            ))}
          </CustomContainer>
        </Col>
        <Col
          md={6}
          className={`${
            styles[imageType != "Landscape Image" && "top-col"]
          } order-md-last pl-3`}
        >
          <Image
            img_path={activeStep.image}
            className={
              imageType === "Landscape Image"
                ? styles["image-landscape"]
                : styles["image-square"]
            }
          />
        </Col>
      </Row>

      <CustomContainer className={"d-block d-lg-none position-relative"}>
        {MobileContent}
      </CustomContainer>
    </>
  );
};

StepProcess.defaultProps = {
  metaData: {},
  className: "",
};
StepProcess.propTypes = {
  metaData: PropTypes.object,
  className: PropTypes.string,
};
export default StepProcess;
